import { render, staticRenderFns } from "./Send-Mail.vue?vue&type=template&id=3ca12aee&scoped=true&"
import script from "./Send-Mail.vue?vue&type=script&lang=js&"
export * from "./Send-Mail.vue?vue&type=script&lang=js&"
import style0 from "./Send-Mail.vue?vue&type=style&index=0&id=3ca12aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca12aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCombobox,VContainer,VFlex,VForm,VIcon,VLayout})
